import PropTypes from 'prop-types';

export default PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string
}));
